const ROUTE_PATHS = {
  preload: '/cashout/:token',
  authentication: '/cashout/auth/:token',
  beneficiary: '/cashout/beneficiary/:token', // @TODO product
  profile: '/cashout/profile/:token',
  waiting: '/cashout/waiting/:token',
  identityValidation: '/cashout/identity/:token',
  error: '/cashout/invalid/request',
  completed: '/cashout/completed/:token',
};

export default ROUTE_PATHS;
